// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const charizard: PokeData = {
  "id": 6,
  "name": "charizard",
  "height": 17,
  "weight": 905,
  "base_experience": 240,
  "types": [
    PokeType.FIRE,
    PokeType.FLYING
  ],
  "api_moves": [
    "scratch",
    "wing-attack",
    "leer",
    "growl",
    "ember",
    "flamethrower",
    "counter",
    "dragon-rage",
    "fire-spin",
    "rage",
    "smokescreen",
    "fury-swipes",
    "slash",
    "scary-face",
    "dragon-breath",
    "metal-claw",
    "crunch",
    "heat-wave",
    "dragon-claw",
    "flare-blitz",
    "air-slash",
    "shadow-claw",
    "fire-fang",
    "flame-burst",
    "inferno"
  ],
  "moves": [
    "scratch",
    "leer",
    "growl",
    "ember",
    "flamethrower",
    "fire-spin",
    "scary-face",
    "dragon-breath",
    "metal-claw",
    "crunch",
    "dragon-claw",
    "flare-blitz",
    "air-slash"
  ],
  "evolution_chain": {
    "id": 2,
    "item": null,
    "species": [
      {
        "name": "charmander",
        "order": 4,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "charmeleon",
        "order": 5,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": 4,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 16,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "charizard",
        "order": 6,
        "types": [
          PokeType.FIRE,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 5,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 36,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 110,
    "speed": 139,
    "ability_power": 151
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
